module.exports = __webpack_public_path__ + "img/icon3.c91ca5bb.svg";